module.exports = __webpack_public_path__ + "static/img/14000199.566a94d0.png";